import React from 'react'
import './CanvasScorecardCell.css'

interface Props {
  items: string[]
  variant: 'measures' | 'targets' | 'initiatives'
  onItemClick?: (item: string) => void
}

export const CanvasScorecardCell: React.FC<Props> = ({ items, variant, onItemClick }) => {
  const className = `canvas-kn-scorecard-cell canvas-kn-scorecard-cell--${variant}`

  if (items.length === 0) {
    return <div className={className}><span className="canvas-kn-scorecard-empty">—</span></div>
  }

  return (
    <div className={className}>
      <ul className="canvas-kn-scorecard-list">
        {items.map((item, i) => (
          <li key={`${item}-${i}`} className="canvas-kn-scorecard-item">
            {onItemClick ? (
              <button
                type="button"
                className="canvas-kn-scorecard-link"
                onClick={() => onItemClick(item)}
                title={item}
              >
                {item}
              </button>
            ) : (
              <span className="canvas-kn-scorecard-text" title={item}>{item}</span>
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}
